import {
  getAllUsersByProjectId,
  sendProjectStructureReview
} from '../services/api/implementation/impl';
import {
  isProjectSetupType,
  resolveManagementReviewer
} from './projectStructurePriorities';

/**
 * After operations completes a project-structure setup step, request a management review.
 * Assigns to mid (Medium) when available, otherwise primary (High).
 */
export async function triggerProjectStructureReview(projectId, setupType) {
  if (!projectId || !isProjectSetupType(setupType)) return null;

  try {
    const usersRes = await getAllUsersByProjectId(projectId, 1, 500);
    const { user, role } = resolveManagementReviewer(usersRes?.data || []);

    const payload = {
      project_id: Number(projectId),
      type: setupType
    };

    if (user?.id) {
      payload.assigned_user_id = user.id;
      payload.reviewer_level = role;
    }

    return await sendProjectStructureReview(payload);
  } catch (err) {
    console.warn('Project structure review could not be sent:', err?.message || err);
    return null;
  }
}
